import React from 'react';
import AppRoutes from './routes.js';
import './App.css';
import './shared/styles/variables.scss';
import './shared/styles/materialTable.scss';
import {
	ThemeProvider,
	StyledEngineProvider,
	createTheme,
} from '@mui/material/styles';
import LanguageSelector from './utils/LanguageSelector.js';
import { withTranslation } from 'react-i18next';
//import makeStyles from '@mui/styles/makeStyles';

const theme = createTheme();

// const useStyles = makeStyles((theme) => {
//   root: {
//     // some CSS that accesses the theme
//   }
// });

function App() {
	return (
		<StyledEngineProvider injectFirst>
			<ThemeProvider theme={theme}>
				<div className="App">
					<div
						style={{
							position: 'fixed',
							top: '20px',
							right: '20px',
							zIndex: 9999,
							backgroundColor: 'white',
							borderRadius: '8px',
							boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
							padding: '8px',
						}}>
						<LanguageSelector />
					</div>
					<AppRoutes />
				</div>
			</ThemeProvider>
		</StyledEngineProvider>
	);
}

export default withTranslation()(App);
